import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        base: function () { return ({
            fontSize: theme.typography.h4.fontSize,
            textAlign: 'center',
            fontWeight: 'bold',
            width: '100%',
        }); },
        echo: function () { return ({
            bottom: -theme.spacing(1),
            fontSize: theme.typography.h2.fontSize,
            opacity: 0.3,
            color: '#bcc0cc',
            position: 'absolute',
            textAlign: 'center',
            fontWeight: 'bold',
            width: '100%',
        }); },
        underline: {
            '&:nth-child(2)': {
                width: 4,
            },
            backgroundColor: theme.palette.primary.main,
            borderRadius: 2,
            height: 4,
            margin: '0 2px',
            width: 50,
        },
    });
});
export default (function (_a) {
    var echo = _a.echo, children = _a.children, underline = _a.underline;
    var style = useStyle({});
    return (React.createElement(Box, { position: "relative", display: "flex", flexDirection: "column", alignItems: "center" },
        React.createElement(Typography, { className: style.echo, component: "span" }, echo),
        React.createElement(Typography, { className: style.base, component: "h2" }, children),
        underline && (React.createElement(Box, { display: "flex" },
            React.createElement(Box, { className: style.underline }),
            React.createElement(Box, { className: style.underline, width: "2" })))));
});
//# sourceMappingURL=index.js.map